import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { logError } from '../../shared/services/logger.service'; // Assuming logger service path
import { exchangeCustomToken } from '../../shared/services/auth.service';

const SelfContainedAuthPage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // The token here is a Firebase *custom token* minted for the user (handed back
    // by the native AR app). We exchange it for a real, auto-refreshing Firebase
    // session, then navigate on — no token is persisted by us.
    const token = searchParams.get('token');
    const destinationPath = params['*']; // This is the full path after /self-contained-auth which is what we want to navigate to

    if (token && destinationPath) {
      exchangeCustomToken(token)
        .then(() => {
          // Add the leading slash if it's missing, otherwise navigate treats it as relative
          const fullDestinationPath = destinationPath.startsWith('/') ? destinationPath : `/${destinationPath}`;
          navigate(fullDestinationPath, { replace: true }); // We want to replace the history entry
        })
        .catch((error) => {
          logError('Error processing self-contained auth', {}, error as Error);
          navigate('/login');
        });
    } else {
      logError('Missing token or destination path in self-contained auth', { hasToken: !!token, destinationPath });
      navigate('/login');
    }
  }, [navigate, params, searchParams]);

  return null;
};

export default SelfContainedAuthPage;
